export default __webpack_public_path__ + "static/media/default-incoming-chat-sound.d5c63167.mp3";